import { useAuthStore } from '@/store/auth'
import { safeReturnTo } from '@/utils/navigation.mjs'
export default defineNuxtRouteMiddleware(async to => {
  if (to.meta.public) return
  const auth = useAuthStore()
  try {
    if (!auth.isLoggedIn) await auth.client.refresh()
    // 역할 변경 후에도 이전 메뉴 권한이 남지 않도록 현재 DB 역할을 다시 확인한다.
    await auth.identify()
  } catch (error) {
    // query까지 허용된 주소면 그대로 돌려보내고, 아니면 경로만 다시 검증한다.
    const returnTo = safeReturnTo(to.fullPath) === to.fullPath ? to.fullPath : safeReturnTo(to.path)
    return error.status === 401 || error.status === 403
      ? navigateTo({ path: '/login', query: { returnTo } }) : navigateTo('/unavailable')
  }
  if (!to.meta.roles?.some(role => auth.member.roles.includes(role))) return navigateTo('/denied')
})
